import { apiClient, CanceledError } from "../api";

export function useMyApiClient() {
  return apiClient;
}

export default useMyApiClient;
export { CanceledError };
